import { ArrowDown, ArrowUp, Plus, Trash2 } from "lucide-react";
import { useAdminContent } from "@/context/AdminContentContext";
import { Field, Panel, TextArea, TextInput } from "@/components/admin/Field";
import { ConfirmDelete } from "@/components/admin/ConfirmDelete";
import { StaffEditor } from "@/pages/admin/StaffEditor";

const ICONS = ["LogIn", "ShieldCheck", "LifeBuoy", "Flag", "Users", "Briefcase", "ShoppingBag", "MessageSquare", "Info", "MapPin", "Car", "Radio", "BadgeCheck", "Wrench"];

export default function EditInformacoes() {
  const { draft, update } = useAdminContent();
  const cards = draft.info_cards;
  const setCards = (fn) => update("info_cards", (c) => fn([...c]));
  const patch = (i, p) => setCards((c) => { c[i] = { ...c[i], ...p }; return c; });
  const move = (i, dir) => setCards((c) => { const j = i + dir; if (j < 0 || j >= c.length) return c; [c[i], c[j]] = [c[j], c[i]]; return c; });
  const remove = (i) => setCards((c) => { c.splice(i, 1); return c; });
  const add = () => setCards((c) => [...c, { id: `card-${Date.now()}`, icon: "Info", title: "Novo cartão", body: "", link_label: "", link_url: "" }]);

  return (
    <>
    <Panel title="Informações essenciais" description="Cartões apresentados na página Informações. Podes reordenar, editar e apagar.">
      <div className="space-y-4" data-testid="info-cards-editor">
        {cards.map((card, i) => (
          <div key={card.id} className="rounded-md border border-eden-border bg-eden-bg p-5" data-testid={`info-card-editor-${card.id}`}>
            <div className="flex items-center justify-between gap-2">
              <span className="font-mono text-xs text-eden-muted">Cartão {i + 1}</span>
              <div className="flex gap-1">
                <button type="button" className="btn-ghost h-8 px-2" onClick={() => move(i, -1)} disabled={i === 0} aria-label="Mover para cima" data-testid={`info-card-up-${card.id}`}><ArrowUp size={14} /></button>
                <button type="button" className="btn-ghost h-8 px-2" onClick={() => move(i, 1)} disabled={i === cards.length - 1} aria-label="Mover para baixo" data-testid={`info-card-down-${card.id}`}><ArrowDown size={14} /></button>
                <ConfirmDelete title="Eliminar cartão?" description={`O cartão "${card.title}" será removido do rascunho. Só afeta o site depois de publicares.`} onConfirm={() => remove(i)} testId={`info-card-delete-${card.id}`}>
                  <button type="button" className="btn-ghost h-8 px-2 text-red-400 hover:text-red-300" aria-label="Eliminar cartão" data-testid={`info-card-delete-${card.id}`}><Trash2 size={14} /></button>
                </ConfirmDelete>
              </div>
            </div>
            <div className="mt-4 grid gap-4 sm:grid-cols-[1fr_160px]">
              <Field label="Título" id={`card-title-${card.id}`}><TextInput id={`card-title-${card.id}`} value={card.title} onChange={(v) => patch(i, { title: v })} maxLength={80} /></Field>
              <Field label="Ícone" id={`card-icon-${card.id}`}>
                <select id={`card-icon-${card.id}`} value={card.icon} onChange={(e) => patch(i, { icon: e.target.value })} className="input-eden" data-testid={`select-card-icon-${card.id}`}>
                  {ICONS.map((ic) => <option key={ic} value={ic}>{ic}</option>)}
                </select>
              </Field>
            </div>
            <div className="mt-4"><Field label="Texto" id={`card-body-${card.id}`}><TextArea id={`card-body-${card.id}`} value={card.body} onChange={(v) => patch(i, { body: v })} rows={3} maxLength={800} /></Field></div>
            <div className="mt-4 grid gap-4 sm:grid-cols-2">
              <Field label="Texto da ligação (opcional)" id={`card-link-label-${card.id}`}><TextInput id={`card-link-label-${card.id}`} value={card.link_label} onChange={(v) => patch(i, { link_label: v })} maxLength={40} /></Field>
              <Field label="URL da ligação (opcional)" id={`card-link-url-${card.id}`}><TextInput id={`card-link-url-${card.id}`} value={card.link_url} onChange={(v) => patch(i, { link_url: v })} maxLength={400} type="url" /></Field>
            </div>
          </div>
        ))}
      </div>
      <button type="button" onClick={add} disabled={cards.length >= 16} className="btn-secondary h-10" data-testid="info-card-add-button"><Plus size={16} /> Adicionar cartão</button>
    </Panel>
    <StaffEditor />
    </>
  );
}
